import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { CURRENT_USER } from 'drapcode-constant';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
import showAlert from '../../common/utils/alert';

export default class ListAppConstants extends Component {
  static propTypes = {
    constants: PropTypes.array.isRequired,
  };

  state = {
    activeConstant: '',
  };

  showConstantValue = (constantType, value, name) => {
    if (name === 'CURRENT_DATE_TIME') {
      return moment(new Date()).format('dddd, MMMM Do YYYY, h:mm:ss a');
    }
    if (name === 'CURRENT_DATE') {
      return moment(new Date()).format('dddd, MMMM Do YYYY');
    }
    if (name === 'CURRENT_TIME') {
      return moment(new Date()).format('hh:mm:ss a');
    }
    if (constantType === 'DATE') {
      return moment(value).format('dddd, MMMM Do YYYY, h:mm:ss a');
    }
    if (constantType === 'BOOLEAN') {
      return value ? 'true' : 'false';
    }
    return value;
  };

  handleDelete = (uuid) => {
    showAlert(
      `You won't be able to revert this`,
      () => this.props.handleDelete(uuid),
      'Yes, delete it!',
    );
  };

  showConstantsDetail = (constant) => {
    const { deleteFlag, isReadOnly } = this.props;
    return (
      <AccordionItem key={constant.name}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <i className={`wb`}></i> <strong>{constant.name}</strong>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div className="table-responsive">
            <table className="table border-none">
              <tbody>
                <tr>
                  <th>Name:</th>
                  <td>{constant.name}</td>
                </tr>
                <tr>
                  <th>Type:</th>
                  <td>{constant.constantType}</td>
                </tr>
                <tr>
                  <th>Value: </th>
                  <td>
                    {this.showConstantValue(constant.constantType, constant.value, constant.name)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="row pt-1">
            <div className="col-11">
              {!constant.isSystemDefined && (
                <div className="row pt-2" style={{ marginBottom: '1em' }}>
                  <div className="col-12">
                    <button
                      className="btn btn-sm btn-theme-submit"
                      onClick={() => {
                        this.props.updateCurrentConstantId(constant.uuid);
                        this.props.toggle('editAppConstant');
                      }}
                      disabled={isReadOnly}
                    >
                      <i className="wb webconnect-pencil"></i> Edit
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      style={{ cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed' }}
                      className="btn btn-sm btn-theme-delete"
                      onClick={() =>
                        deleteFlag && !isReadOnly ? this.handleDelete(constant.uuid) : undefined
                      }
                      disabled={isReadOnly}
                    >
                      <i className="wb webconnect-trash-solid"></i> Delete
                      {deleteFlag ? null : (
                        <>
                          &nbsp;
                          <TooltipInfo
                            title={description}
                            headerText={`Permission Disabled!`}
                            showHeader={true}
                            showArrow={true}
                          />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  render() {
    const { constants } = this.props;
    if (constants && constants.length > 0) {
      return (
        <div className="row">
          <div className="col-12">
            <Accordion allowZeroExpanded>
              {constants
                .filter((constant) => constant.name !== CURRENT_USER)
                .map((constant) => this.showConstantsDetail(constant))}
            </Accordion>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}
